"use client";

import * as React from "react";
import { Sheet, SheetContent } from "../primitives/sheet";

export type RecordDrawerProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
};

/**
 * RecordDrawer — default presentation for single-record view/edit (Slide-over).
 */
export function RecordDrawer({
  open,
  onOpenChange,
  title,
  description,
  children,
  footer,
  className,
}: RecordDrawerProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent title={title} description={description} className={className} bodyClassName="flex flex-col overflow-hidden p-0">
        <div className="min-h-0 flex-1 space-y-6 overflow-y-auto px-6 py-4">{children}</div>
        {footer ? (
          <div className="shrink-0 border-t border-border bg-card px-6 py-4">
            {footer}
          </div>
        ) : null}
      </SheetContent>
    </Sheet>
  );
}
